import ob1993 from "@/assets/json/hrcard/1993.json";
import ob1994 from "@/assets/json/hrcard/1994.json";
import ob1995 from "@/assets/json/hrcard/1995.json";
import ob1996 from "@/assets/json/hrcard/1996.json";
import ob1997 from "@/assets/json/hrcard/1997.json";
import ob1998 from "@/assets/json/hrcard/1998.json";
import ob1999 from "@/assets/json/hrcard/1999.json";
import ob2000 from "@/assets/json/hrcard/2000.json";
import ob2001 from "@/assets/json/hrcard/2001.json";
import ob2002 from "@/assets/json/hrcard/2002.json";
import ob2003 from "@/assets/json/hrcard/2003.json";
import ob2004 from "@/assets/json/hrcard/2004.json";
import ob2005 from "@/assets/json/hrcard/2005.json";
import ob2006 from "@/assets/json/hrcard/2006.json";
import ob2007 from "@/assets/json/hrcard/2007.json";
import ob2008 from "@/assets/json/hrcard/2008.json";
import ob2009 from "@/assets/json/hrcard/2009.json";
import ob2010 from "@/assets/json/hrcard/2010.json";
import ob2011 from "@/assets/json/hrcard/2011.json";
import ob2012 from "@/assets/json/hrcard/2012.json";

// https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Array/flat
export const ylist = [ob1993, ob1994, ob1995, ob1996, ob1997, ob1998, ob1999, ob2000, ob2001, ob2002, ob2003, ob2004, ob2005, ob2006, ob2007, ob2008, ob2009, ob2010, ob2011, ob2012].flat();
